import type { ICartPricing } from 'hooks/useDCSTypes';
import { useSubscriptionsState } from 'hooks/useSubscriptionsState';
import React, { FC } from 'react';
import { getPricingData, calculateSubscriptionMonthlyPrice } from 'components/Pricing/utils/PricingUtil';
import { Pricing } from 'components/Pricing/PricingComponents/Pricing';

interface IBundlePricingProps {
  pricing: ICartPricing;
  showSoftwareMonthlyPlan?: boolean;
}

export const BundlePricing: FC<IBundlePricingProps> = ({ pricing, showSoftwareMonthlyPlan = true }) => {
  const { subscriptionsState } = useSubscriptionsState();

  const { msrpPrice, upfrontPrice, softwarePlanMonthlyPrice } = getPricingData(
    pricing,
    showSoftwareMonthlyPlan,
  );
  const subscriptionMonthlyPrice = calculateSubscriptionMonthlyPrice(
    subscriptionsState,
    pricing.installmentPlans,
    pricing.monthlyAdditionalPrice.value,
  );

  return (
    <Pricing
      msrpPrice={msrpPrice}
      upfrontPrice={upfrontPrice}
      subscriptionMonthlyPrice={subscriptionMonthlyPrice}
      softwarePlanMonthlyPrice={softwarePlanMonthlyPrice}
    />
  );
};
